export * from './SynchronizeArrowsMiniIcon'
